(function ($) {
  $(function () {
    if (!$('.shop-facets').length) return;

    // Collapse/expand a filter section (soul-flower style: caret in the head).
    // Open/closed choices survive refreshes and page loads via sessionStorage.
    const STORE_KEY = 'phentFacetSections';

    function readState() {
      try {
        return JSON.parse(sessionStorage.getItem(STORE_KEY)) || {};
      } catch (e) {
        return {};
      }
    }

    function setOpen($section, open) {
      $section.toggleClass('is-open', open);
      $section.find('.facet-section__toggle').attr('aria-expanded', open ? 'true' : 'false');
    }

    const state = readState();
    $('.facet-section[data-facet]').each(function () {
      const name = $(this).data('facet');
      if (name in state) {
        setOpen($(this), !!state[name]);
      }
    });

    $(document).on('click', '.facet-section__toggle', function () {
      const $section = $(this).closest('.facet-section');
      const open = !$section.hasClass('is-open');
      setOpen($section, open);

      const current = readState();
      current[$section.data('facet')] = open;
      sessionStorage.setItem(STORE_KEY, JSON.stringify(current));
    });

    // FacetWP fills the facet boxes client-side; a facet with no choices
    // for the current results (e.g. Kleur on a category without colours)
    // stays an empty div — hide its whole section, divider included.
    function hideEmptySections() {
      $('.facet-section').each(function () {
        const $facet = $(this).find('.facetwp-facet');
        if (!$facet.length) return;
        $(this).toggleClass('is-empty', !$facet.children().length);
      });
    }

    // A section holding an active filter should never sit collapsed
    function openActiveSections() {
      if (!window.FWP || !window.FWP.facets) return;
      Object.keys(window.FWP.facets).forEach(function (name) {
        const val = window.FWP.facets[name];
        if (val && val.length) {
          setOpen($('.facet-section[data-facet="' + name + '"]'), true);
        }
      });
    }

    // Per-section Reset link
    $(document).on('click', '[data-facet-reset]', function () {
      if (window.FWP) {
        window.FWP.reset($(this).data('facet-reset'));
      }
    });

    // Skeleton cards over the grid while FacetWP fetches filtered results
    // (reuses the shimmer from the product-gallery skeleton). FacetWP
    // replaces the template's innerHTML when done, wiping the cards.
    document.addEventListener('facetwp-refresh', function () {
      // While the request is in flight each section's caret becomes a
      // spinner, like the header search's in-button indicator. Also on
      // the initial load, when the facet bodies are still empty divs.
      $('.shop-facets').addClass('is-loading');

      if (!window.FWP || !window.FWP.loaded) return; // skip the initial load

      const $tpl = $('.facetwp-template');
      if (!$tpl.length || $tpl.hasClass('is-loading')) return;

      const count = Math.min($tpl.find('li.product').length || 6, 9);
      let cards = '';
      for (let i = 0; i < count; i++) {
        cards +=
          '<div class="facet-skeleton__card">' +
            '<span class="phent-skeleton-box facet-skeleton__img"></span>' +
            '<span class="phent-skeleton-box facet-skeleton__line"></span>' +
            '<span class="phent-skeleton-box facet-skeleton__line facet-skeleton__line--short"></span>' +
          '</div>';
      }

      $tpl.addClass('is-loading').append('<div class="facet-skeleton">' + cards + '</div>');
    });

    document.addEventListener('facetwp-loaded', function () {
      $('.shop-facets').removeClass('is-loading');
      $('.facetwp-template').removeClass('is-loading').find('.facet-skeleton').remove();
      hideEmptySections();
      openActiveSections();
    });

    // After a filter change, bring the top of the result list back into
    // view: with a long grid the user is often scrolled deep into the page
    // when they tick a facet, and the new results would otherwise render
    // off-screen. Skipped on the initial load and on pager clicks, which
    // FacetWP scrolls itself via the pager facet's scroll target (FWP still
    // holds that target when the DOM event fires; its own hook runs after).
    document.addEventListener('facetwp-loaded', function () {
      if (!window.FWP || !window.FWP.loaded || window.FWP.scroll_target) return;

      const tpl = document.querySelector('.facetwp-template');
      if (!tpl) return;

      const header = document.getElementById('masthead');
      const offset = (header ? header.offsetHeight : 0) + 16;
      const top = tpl.getBoundingClientRect().top;

      if (top >= offset) return; // list top already visible below the sticky header

      window.scrollBy({ top: top - offset, behavior: 'smooth' });
    });

    // /nieuw/: the toolbar's FacetWP sort facet can't be rendered twice, so
    // the drawer gets a proxy dropdown that mirrors it and drives it. The
    // facet's select is rendered by FacetWP after DOM-ready, so the proxy is
    // built lazily on facetwp-loaded.
    const $sortSlot = $('.shop-sidebar-sort__slot');

    if ($sortSlot.length) {
      const getFacetSelect = () => $('.shop-sort .facetwp-facet select');
      let $proxy = null;

      const syncProxy = () => {
        const $facet = getFacetSelect();
        if (!$facet.length) return;

        if (!$proxy) {
          $proxy = $('<select class="orderby" aria-label="Sorteren"></select>');
          $proxy.on('change', function () {
            const $f = getFacetSelect();
            if ($f.length) {
              $f.val(this.value);
              $f[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          $sortSlot.append($proxy);
        }

        $proxy.html($facet.html()).val($facet.val());
      };

      syncProxy();
      document.addEventListener('facetwp-loaded', syncProxy);
    }
  });
})(jQuery);
